import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "text-h6 text--text mb-6" }, [
        _vm._v("\n    Вопросы и ответы\n  "),
      ]),
      _vm._v(" "),
      _c(
        VExpansionPanels,
        { attrs: { multiple: "" } },
        _vm._l(_vm.CLUB_CARD_FAQ, function (faq, index) {
          return _c(
            VExpansionPanel,
            { key: index },
            [
              _c(
                VExpansionPanelHeader,
                {
                  staticClass: "text-body-1 pl-4 pr-2",
                  attrs: { "expand-icon": "ui-icon-arrow-down" },
                },
                [_vm._v("\n        " + _vm._s(faq.title) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                VExpansionPanelContent,
                { staticClass: "text-body-1 mx-n2" },
                [
                  _vm._v(
                    "\n        " + _vm._s(faq.sentences.join(" ")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }